// Components/JoinNowModalManager.js
import {
  Box,
  Button,
  Modal,
  Paper,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import LaptopMacOutlinedIcon from "@mui/icons-material/LaptopMacOutlined";
import { PLACEMENT_COURSE_LEVELS } from "../../../constants/courseLevels";
import PaymentOptions from "./PaymentOptions";

const orderOfLevels = PLACEMENT_COURSE_LEVELS;

const JoinNowModalManager = ({
  open,
  onClose,
  isAuthenticated,
  courseTitle,
  parentTitle,
  teacherCourseId,
  teacherId,
  parentCourseId,
  Tprice,
  priceCurrency,
  bookingScope = "single",
  termsAcceptance,
  termsAcceptanceComplete = false,
  placementRequired,
  placementTargetLevel,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation("ui");
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  const { status, statusError } = useSelector((s) => s.studentPlacement);

  if (!open) return null;

  let content;
  const needsPlacement = placementRequired === true || (placementRequired == null && courseTitle !== "A1" && orderOfLevels.includes(parentTitle));
  const effectivePlacementLevel = placementTargetLevel || parentTitle;
  const placementStatusMatchesCourse =
    !needsPlacement || !status?.targetLevel || status.targetLevel === effectivePlacementLevel;
  const hasGuestPlacementToken = !!localStorage.getItem("placementGuestToken");
  const pickPlacementMessage = () => {
    if (i18n.language?.startsWith("ar")) {
      return status?.studentMessageAr || "";
    }
    if (i18n.language?.startsWith("de")) {
      return status?.studentMessageDe || "";
    }
    return status?.studentMessageEn || status?.studentMessage || status?.studentMessageDe || "";
  };
  // 1ÃƒÆ’Ã‚Â¯Ãƒâ€šÃ‚Â¸Ãƒâ€šÃ‚ÂÃƒÆ’Ã‚Â¢Ãƒâ€ Ã¢â‚¬â„¢Ãƒâ€šÃ‚Â£ Not authenticated ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ signup
  if (!isAuthenticated && !needsPlacement) {
    content = (
      <Paper sx={{ p: 4, borderRadius: 2, textAlign: "center" }}>
        <Typography variant="h6" gutterBottom>
          {t("joinNowContent.login.title")}
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={() => navigate("/login")}
        >
          {t("joinNowContent.login.cta")}
        </Button>
      </Paper>
    );
  }

  // 2ÃƒÆ’Ã‚Â¯Ãƒâ€šÃ‚Â¸Ãƒâ€šÃ‚ÂÃƒÆ’Ã‚Â¢Ãƒâ€ Ã¢â‚¬â„¢Ãƒâ€šÃ‚Â£ Course A1.1 ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ Payment modal (no placement test required)
  else if (!needsPlacement) {
    content = (
      <Paper sx={{ p: 4, borderRadius: 2 }}>
        <PaymentOptions
          onClose={onClose}
          level={courseTitle}
          teacherCourseId={teacherCourseId}
          teacherId={teacherId}
          parentTitle={parentTitle}
          parentCourseId={parentCourseId}
          Tprice={Tprice}
          priceCurrency={priceCurrency}
          bookingScope={bookingScope}
          termsAcceptance={termsAcceptance}
          termsAcceptanceComplete={termsAcceptanceComplete}
        />
      </Paper>
    );
  }

  // 3ÃƒÆ’Ã‚Â¯Ãƒâ€šÃ‚Â¸Ãƒâ€šÃ‚ÂÃƒÆ’Ã‚Â¢Ãƒâ€ Ã¢â‚¬â„¢Ãƒâ€šÃ‚Â£ Higher than A1.1 ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ Placement test logic
  else {
    // 3a. Error fetching placement test status
    if (statusError !== null && (isAuthenticated || hasGuestPlacementToken)) {
      content = (
        <Paper sx={{ p: 4, borderRadius: 2, textAlign: "center" }}>
          <Typography color="error">
            {t("joinNowContent.statusError")}
          </Typography>
        </Paper>
      );
    }

    // 3b. Never started placement
    else if (!status?.hasSession || !placementStatusMatchesCourse) {
      content = isMobile ? (
        <Paper sx={{ p: 4, borderRadius: 2, textAlign: "center" }}>
          <LaptopMacOutlinedIcon
            sx={{ fontSize: 64, color: "text.secondary", mb: 2 }}
          />
          <Typography variant="h6" gutterBottom>
            {t("joinNowContent.placementTestRequired.desktopOnlyTitle")}
          </Typography>
          <Typography sx={{ mb: 2 }}>
            {t("joinNowContent.placementTestRequired.desktopOnlyMessage")}
          </Typography>
          <Button variant="contained" onClick={onClose}>
            {t("joinNowContent.placementTestRequired.desktopOnlyCta")}
          </Button>
        </Paper>
      ) : (
        <Paper sx={{ p: 4, borderRadius: 2, textAlign: "center" }}>
          <Typography variant="h6" gutterBottom>
            {t("joinNowContent.placementTestRequired.title")}
          </Typography>
          <Typography sx={{ mb: 2 }}>
            {t("joinNowContent.placementTestRequired.message")}
          </Typography>
          <Button variant="contained" onClick={onClose}>
            {t("joinNowContent.placementTestRequired.openTabCta", {
              defaultValue: "Open the placement test tab",
            })}
          </Button>
        </Paper>
      );
    }

    // 3c. Placement test finalized
    else if (status.finalized && placementStatusMatchesCourse) {
      if (status.allowBooking === false) {
        content = (
          <Paper sx={{ p: 4, borderRadius: 2, textAlign: "center" }}>
            <Typography variant="h6" gutterBottom>
              {t("joinNowContent.placementFinalized.lower.title")}
            </Typography>
            <Typography sx={{ mb: 2 }}>
              {pickPlacementMessage() ||
                t("joinNowContent.placementFinalized.lower.desc", {
                  finalLevel: status.finalLevel,
                  requested: courseTitle,
                })}
            </Typography>
            <Button
              variant="contained"
              color="primary"
              onClick={() =>
                navigate(`/german-language?level=${status.finalLevel || "A1"}#courses-section`, {
                  replace: true,
                })
              }
            >
              {t("joinNowContent.placementFinalized.lower.cta", {
                finalLevel: status.finalLevel || "A1",
              })}
            </Button>
          </Paper>
        );
        return (
          <Modal open={open} onClose={onClose}>
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                minWidth: { xs: "100vw", sm: "500px" },
                maxWidth: { xs: "100vw", sm: "600px" },
                maxHeight: { xs: "100dvh", sm: "92vh" },
                overflowY: "auto",
                p: 0,
              }}
            >
              {content}
            </Box>
          </Modal>
        );
      }
      if (!isAuthenticated) {
        content = (
          <Paper sx={{ p: 4, borderRadius: 2, textAlign: "center" }}>
            <Typography variant="h6" gutterBottom>
              {t("joinNowContent.placementGuestCompleted.title")}
            </Typography>
            <Typography sx={{ mb: 2 }}>
              {t("joinNowContent.placementGuestCompleted.desc")}
            </Typography>
            <Button
              variant="contained"
              color="primary"
              onClick={() => navigate("/login")}
            >
              {t("joinNowContent.placementGuestCompleted.cta")}
            </Button>
          </Paper>
        );
      } else {
      const finalLevelIndex = orderOfLevels.indexOf(status.finalLevel);
      const requestedLevelIndex = orderOfLevels.indexOf(effectivePlacementLevel);

      if (finalLevelIndex > requestedLevelIndex) {
        // User scored higher ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ allow booking this one OR higher
        content = (
          <Paper sx={{ p: 4, borderRadius: 2, textAlign: "center" }}>
            <Typography variant="h6" gutterBottom>
              {t("joinNowContent.placementFinalized.higher.title")}
            </Typography>
            <Typography sx={{ mb: 2 }}>
              {t("joinNowContent.placementFinalized.higher.desc", {
                finalLevel: status.finalLevel,
                requested: courseTitle,
              })}
            </Typography>

            {/* Book requested level = Payment modal */}
            <Box sx={{ mb: 3 }}>
              <PaymentOptions
                onClose={onClose}
                level={courseTitle}
                teacherCourseId={teacherCourseId}
                teacherId={teacherId}
                parentCourseId={parentCourseId}
                Tprice={Tprice}
                parentTitle={parentTitle}
                priceCurrency={priceCurrency}
                bookingScope={bookingScope}
                termsAcceptance={termsAcceptance}
                termsAcceptanceComplete={termsAcceptanceComplete}
              />
            </Box>

            {/* Or go to higher level */}
            <Button
              variant="outlined"
              onClick={() =>
                navigate(`/german-language?level=${status.finalLevel}#courses-section`, {
                  replace: true,
                })
              }
            >
              {t("joinNowContent.placementFinalized.higher.bookFinal", {
                finalLevel: status.finalLevel,
              })}
            </Button>
          </Paper>
        );
      } else if (finalLevelIndex === requestedLevelIndex) {
        // User scored exactly this level ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ allow booking
        if (courseTitle === parentTitle) {
          content = (
            <Paper sx={{ p: 4, borderRadius: 2 }}>
              <PaymentOptions
                onClose={onClose}
                level={courseTitle}
                teacherCourseId={teacherCourseId}
                teacherId={teacherId}
                parentCourseId={parentCourseId}
                Tprice={Tprice}
                parentTitle={parentTitle}
                priceCurrency={priceCurrency}
                bookingScope={bookingScope}
                termsAcceptance={termsAcceptance}
                termsAcceptanceComplete={termsAcceptanceComplete}
              />
            </Paper>
          );
        } else {
          // e.g. B1.2 requested, but placement only gave B1 ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ must start at B1.1
          content = (
            <Paper sx={{ p: 4, borderRadius: 2, textAlign: "center" }}>
              <Typography variant="h6" gutterBottom>
                {t("joinNowContent.placementFinalized.mustStart.title")}
              </Typography>
              <Typography sx={{ mb: 2 }}>
                {t("joinNowContent.placementFinalized.mustStart.desc", {
                  finalLevel: status.finalLevel,
                  requested: courseTitle,
                })}
              </Typography>
              <Button
                variant="contained"
                color="primary"
                onClick={() =>
                  navigate(`/german-language?level=${status.finalLevel}#courses-section`, {
                    replace: true,
                  })
                }
              >
                {t("joinNowContent.placementFinalized.mustStart.cta", {
                  finalLevel: `${status.finalLevel}`,
                })}
              </Button>
            </Paper>
          );
        }
      } else {
        // User scored lower ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ redirect them to the lower level
        content = (
          <Paper sx={{ p: 4, borderRadius: 2, textAlign: "center" }}>
            <Typography variant="h6" gutterBottom>
              {t("joinNowContent.placementFinalized.lower.title")}
            </Typography>
            <Typography sx={{ mb: 2 }}>
              {t("joinNowContent.placementFinalized.lower.desc", {
                finalLevel: status.finalLevel,
                requested: courseTitle,
              })}
            </Typography>
            <Button
              variant="contained"
              color="primary"
              onClick={() =>
                navigate(`/german-language?level=${status.finalLevel}#courses-section`, {
                  replace: true,
                })
              }
            >
              {t("joinNowContent.placementFinalized.lower.cta", {
                finalLevel: status.finalLevel,
              })}
            </Button>
          </Paper>
        );
      }
      }
    }

    // 3d. Awaiting teacher review
    else if (status.awaitingTeacherReview) {
      content = (
        <Paper sx={{ p: 4, borderRadius: 2, textAlign: "center" }}>
          <Typography variant="h6" gutterBottom>
            {t("joinNowContent.placementAwaitingReview.title")}
          </Typography>
          <Typography>
            {t("joinNowContent.placementAwaitingReview.desc")}
          </Typography>
        </Paper>
      );
    }

    // 3e. Submitted or still in progress
    else if (status.submitted || status.inProgress) {
      content = (
        <Paper sx={{ p: 4, borderRadius: 2, textAlign: "center" }}>
          <Typography variant="h6" gutterBottom>
            {t("joinNowContent.placementInProgress.title")}
          </Typography>
          <Typography>
            {t("joinNowContent.placementInProgress.desc")}
          </Typography>
        </Paper>
      );
    }

    // 3f. Blacklisted
    else if (status.blacklisted) {
      content = (
        <Paper sx={{ p: 4, borderRadius: 2, textAlign: "center" }}>
          <Typography variant="h6" gutterBottom color="error">
            {t("joinNowContent.placementBlacklisted.title")}
          </Typography>
          <Typography>
            {t("joinNowContent.placementBlacklisted.desc")}
          </Typography>
        </Paper>
      );
    }

    // 3g. Fallback
    else {
      content = (
        <Paper sx={{ p: 4, borderRadius: 2, textAlign: "center" }}>
          <Typography>{t("joinNowContent.unknownPlacementStatus")}</Typography>
        </Paper>
      );
    }
  }

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          minWidth: { xs: "100vw", sm: "500px" },
          minHeight: { xs: "auto", sm: "300px" },
          width: { xs: "100vw", sm: "auto" },
          maxWidth: { xs: "100vw", sm: "600px" },
          maxHeight: { xs: "100dvh", sm: "92vh" },
          overflowY: "auto",
          overscrollBehavior: "contain",
          p: { xs: 0, sm: 0 },
        }}
      >
        <Button
          onClick={() => {
            onClose();
            dispatch({ type: "CLEAR_STATUS_ERROR", teacherCourseId });
            if (parentCourseId) {
              dispatch({ type: "CLEAR_STATUS_ERROR", parentCourseId });
            }
          }}
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            minWidth: 0,
            padding: "4px",
            zIndex: 1,
          }}
        >
          <CloseIcon fontSize="small" />
        </Button>
        {content}
      </Box>
    </Modal>
  );
};

export default JoinNowModalManager;
